exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fab--btn.left[data-v-0d0b6088]{left:10px}.fab--btn.right[data-v-0d0b6088]{right:10px}.fab--btn[data-v-0d0b6088]{position:absolute;bottom:10px;z-index:15000}", ""]);

// exports
